import { IconButton, Theme, Tooltip } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { K1Productionsitesworlwide } from '@e3dc-react/icons'
import React from 'react'
import { useDispatch } from 'react-redux'
import { appUpdate } from '../../State/App/AppActions'
import { useTypedSelector } from '../../State/RootReducer'
import { useCustomTranslation } from '../../Hooks/useCustomTranslation'

interface StyleProps {
  isEditMode?: boolean
}

const useStyles = makeStyles<StyleProps>()((theme: Theme, props) => ({
  icon: {
    color: props.isEditMode ? theme.palette.primary.light : 'inherit',
  },
}))

const LanguageEditorMenu: React.VFC = () => {
  const isEditMode = useTypedSelector(store => store.app.languageEditMode)
  const dispatch = useDispatch()
  const { classes } = useStyles({ isEditMode })
  const { t } = useCustomTranslation()

  const onClick = (): void => {
    dispatch(appUpdate({ languageEditMode: !isEditMode }))
  }
  return (
    <Tooltip title={t('common.languageEditModeTooltip') as string}>
      <span>
        <IconButton onClick={onClick} className={classes.icon} data-qa={'button-header-translations-mode'} size="large">
          <K1Productionsitesworlwide />
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default LanguageEditorMenu
